import { Link } from 'react-router-dom'

export function Footer() {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="border-t-2 border-slate-200 bg-slate-100 shadow-inner">
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
        <div className="flex flex-col gap-10 lg:flex-row lg:items-start lg:justify-between">
          <div className="lg:max-w-md">
            <h3 className="mb-4 text-lg font-semibold text-gray-900">
              White Gi
            </h3>
            <p className="text-sm text-gray-600">
              Your personal Brazilian Jiu-Jitsu training companion. Organize
              techniques, build series, and track your progress on the mats.
            </p>
          </div>

          <div className="flex flex-col gap-8 sm:flex-row sm:flex-wrap sm:gap-10 lg:gap-16">
            <div>
              <h3 className="mb-4 text-sm font-semibold uppercase tracking-wider text-gray-900">
                Resources
              </h3>
              <ul className="space-y-2">
                <li>
                  <a
                    href="https://github.com/kchima85/white-gi/issues"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm text-gray-600 hover:text-gray-900"
                  >
                    Support
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h3 className="mb-4 text-sm font-semibold uppercase tracking-wider text-gray-900">
                Legal
              </h3>
              <ul className="space-y-2">
                <li>
                  <Link
                    to="/terms"
                    className="text-sm text-gray-600 hover:text-gray-900"
                  >
                    Terms of Service
                  </Link>
                </li>
                <li>
                  <Link
                    to="/privacy"
                    className="text-sm text-gray-600 hover:text-gray-900"
                  >
                    Privacy Policy
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h3 className="mb-4 text-sm font-semibold uppercase tracking-wider text-gray-900">
                Connect
              </h3>
              <ul className="space-y-2">
                <li>
                  <a
                    href="mailto:support@white-gi.com"
                    className="text-sm text-gray-600 hover:text-gray-900"
                  >
                    Contact
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-8 border-t border-gray-200 pt-8">
          <p className="text-center text-sm text-gray-600">
            © {currentYear} White Gi. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  )
}
